import React from 'react';
import styles from './notification_item_skeleton.module.less';
import cn from 'classnames';

interface i_notification_item_skeleton {
    delay?: number;
    site?: string;
}
export const Notification_item_skeleton = ({delay = 0, site}
  : i_notification_item_skeleton)=>{
    const toolip = site === 'toolip';
    const anim_style = {animationDelay: `${delay}ms`};
    return <div className={cn(styles.notification_item_skeleton,
      styles[site])} style={anim_style}>
      <div className={cn(styles.icon, styles[site])}/>
      <div className={styles.content}>
        <div className={`${cn(styles.line, styles[site])} ${styles.title}`}/>
        <div className={`${cn(styles.line, styles[site])}`}/>
        <div className={`${cn(styles.line, styles[site])}`}/>
        <div className={`${cn(styles.line, styles[site])}`}/>
        {!toolip && <div className={`${styles.line}`}/>}
      </div>
    </div>;
};
